import { type ViewVersions } from '@cognite/apm-client';

import {
  CDM_INFIELD_SCHEMA_MODEL_VERSION,
  VIEW_REFERENCES_CDM_SOLUTION_MODEL,
} from '../../constants/cdm-infield-data-model';
import { type InfieldViewReferences } from '../../constants/cdm-infield-data-model';
import type { ViewMappingReference } from '../../features/app-config/cdm-types';

export const isViewReferenceMatch = (
  viewRefA: ViewMappingReference,
  viewRefB: ViewMappingReference
): boolean =>
  viewRefA.externalId === viewRefB.externalId &&
  viewRefA.space === viewRefB.space &&
  viewRefA.version === viewRefB.version;

export const getCdmViewReferencesFromModelVersion = (
  modelVersion: string = CDM_INFIELD_SCHEMA_MODEL_VERSION
): InfieldViewReferences => {
  switch (modelVersion) {
    case CDM_INFIELD_SCHEMA_MODEL_VERSION:
      return VIEW_REFERENCES_CDM_SOLUTION_MODEL;
    default:
      throw new Error(`Unsupported model version: ${modelVersion}`);
  }
};

export const getRequiredAssetViewReferences = (
  assetView: ViewMappingReference | undefined
): ViewMappingReference[] => {
  const { infieldAsset } = getCdmViewReferencesFromModelVersion();
  return [infieldAsset, assetView ?? infieldAsset];
};

export const convertViewReferencesToViewVersions = (
  viewReferences: InfieldViewReferences
): ViewVersions => {
  return {
    ACTION: viewReferences.infieldAction.version,
    ANNOTATION: viewReferences.cdmAnnotation.version,
    ASSET: viewReferences.infieldAsset.version,
    CHECKLIST_ITEM: viewReferences.infieldChecklistItem.version,
    CHECKLIST: viewReferences.infieldChecklist.version,
    CONDITION: viewReferences.infieldCondition.version,
    CONDITIONAL_ACTION: viewReferences.infieldConditionalAction.version,
    SCHEDULE: viewReferences.infieldSchedule.version,
    MEASUREMENT_READING: viewReferences.infieldMeasurementReading.version,
    OBSERVATION: viewReferences.infieldFieldObservation.version,
    TEMPLATE_ITEM: viewReferences.infieldTemplateItem.version,
    TEMPLATE: viewReferences.infieldTemplate.version,
    TIMESERIES: viewReferences.infieldTimeseries.version,
    CAD_MODEL: viewReferences.cdmCadModel.version,
    COGNITE_3D_OBJECT: viewReferences.cdm3dObject.version,
    COGNITE_CAD_NODE: viewReferences.cdmCadNode.version,
    COGNITE_CAD_MODEL: viewReferences.cdmCadModel.version,
    COGNITE_CAD_REVISION: viewReferences.cdmCadRevision.version,
    COGNITE_3D_MODEL: viewReferences.cdm3dModel.version,
    COGNITE_SOLUTION_TAG: viewReferences.appsSharedCogniteSolutionTag.version,
  };
};
